let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("ifbX2")).then(() => parcelRequire('lcNvE'));